@if (formGroup) {
    <div [ngClass]="question.styles" [formGroup]="formGroup">
        @for (option of question.questions; track option; let isLast = $last) {
            <mat-checkbox
                [formControlName]="option.key"
                class="ca-checkbox"
                [disableRipple]="true"
                [id]="question.groupName + option.key"
                [attr.data-testid]="question.groupName + option.key"
                [ngClass]="{ 'mb-0': isLast, hidden: option.hidden }"
            >
                {{ option.label | translate }}
            </mat-checkbox>
        }
        @if (question.validators.length) {
            <div class="ca-subscript relative mt-2">
                @if (isInvalid && isTouched) {
                    <div class="absolute ca-error-message" @slideDown>
                        <ca-form-error-message>
                            {{ errorMessage | translate }}
                        </ca-form-error-message>
                    </div>
                }
            </div>
        }
    </div>
}
